<template>
  <v-app id="portal">
    <v-content class="px-3">
      <titulo-responsivo :titulo="locale[local].screen.informesRendimentos.string001" />
      <v-divider />

      <template>
        <v-row justify="space-around">
          <v-col
            cols="12"
            sm="8"
            md="6"
            lg="4"
          >
            <v-slide-group show-arrows>
              <v-chip-group
                mandatory
                active-class="white--text primary "
                v-model="filterPeriod"
              >
                <v-chip
                  v-for="option in filterOptions"
                  :key="option.year"
                  @click="setFilterOption(option.year)"
                >
                  {{ option.year }}
                </v-chip>
              </v-chip-group>
            </v-slide-group>
          </v-col>
        </v-row>
      </template>

      <template v-if="!showError">
        <v-row justify="space-around">
          <v-col
            cols="12"
            md="6"
            class="py-0"
          >
            <v-skeleton-loader
              :loading="loading"
              transition="scale-transition"
              class="mx-auto"
              max-width="344"
              :types="{ skeleton: 'card' }"
              type="skeleton"
            >
              <v-card
                class="mx-auto"
                max-width="344"
              >
                <v-card-text>
                  <p
                    class="display-1 text--primary"
                    v-if="filterOptions[filterPeriod] != undefined"
                  >
                    {{ locale[local].screen.informesRendimentos.string002 }}
                    {{ filterOptions[filterPeriod].year }}
                  </p>

                  <div class="text--primary">
                    {{ infoMessage }}
                  </div>
                </v-card-text>
                <v-card-actions class="justify-center" v-if="filterOptions[filterPeriod] != undefined">
                  <v-tooltip bottom="">
                    <template v-slot:activator="{ on }">
                      <v-btn
                        v-on="on"
                        color="primary"
                        class="ma-2 white--text"
                        :href="
                          'data:application/octet-stream;base64,' +
                            getBase64PDF()
                        "
                        download="informe-rendimentos.pdf"
                        :disabled="showError || loading"
                        width="200"
                        max-width="200"
                      >
                        <span>
                          {{ locale[local].screen.informesRendimentos.string003 }}
                        </span>
                        <v-icon
                          right
                          medium
                        >
                          mdi-printer
                        </v-icon>
                      </v-btn>
                    </template>
                    <span>{{ locale[local].screen.informesRendimentos.string004 }}</span>
                  </v-tooltip>
                </v-card-actions>
              </v-card>
            </v-skeleton-loader>
          </v-col>
        </v-row>
      </template>

      <template v-if="showError">
        <v-row justify="space-around">
          <v-col
            cols="12"
            md="6"
            class="py-0"
          >
            <v-card
              class="mx-auto"
              max-width="344"
            >
              <v-card-text>
                <p class="headline text--primary">
                  Erro:
                </p>

                <div class="subtitle-1 text--primary">
                  {{ errorMessage }}
                </div>
              </v-card-text>
            </v-card>
          </v-col>
        </v-row>
      </template>
    </v-content>
  </v-app>
</template>

<script>
import moment from "moment";
import Service from "@/components/api/Service";
import { locale } from '../locale/locale';

export default {
  data: () => ({
    service: new Service(),
    showError: false,
    filterPeriod: 0,
    filterOptions: [],
    receiptBase64PDF: "",
    infoMessage: "",
    loading: false,
  }),
  created() {
    moment.locale("pt-br");
    this.populateFilers();
  },
  methods: {
    moment: function () {
      return moment();
    },
    async populateFilers() {
      const {
        data: { ttAnoRendimento },
      } = await this.service.getAnosParaRendimentos({
        codPessoa: parseInt(localStorage.getItem("codPessoa")),
      });

      if (ttAnoRendimento) {
        const anos = ttAnoRendimento?.map((item) => ({
          year: item.anoRendimento,
        }));

        this.filterOptions = anos.reverse();

        var filterSelected = this.filterOptions[0];
        this.setFilterOption(filterSelected.year);
      }

      this.infoMessage = locale[window.local].screen.informesRendimentos.string005;

      // const dateStart = moment();
      // const dateEnd = moment().add(qtdYears, "y");

      // while (dateEnd.diff(dateStart, "years") <= 0) {
      //   this.filterOptions =;
      //   dateStart.add(-1, "year");
      // }
    },
    setFilterOption(year) {
      this.getReceipt(year);
    },
    async getReceipt(year) {
      try {
        this.cleanErrorMessage();

        this.loading = true;

        var response = await this.service.getAnualIncomeReport({
          codPessoa: parseInt(localStorage.getItem("codPessoa")),
          ano: parseInt(year),
        });

        if (response.status === 200) {
          if (response.data.retorno) {
            if (response.data.retorno[0].estatus === "Erro") {
              throw new Error(response.data.retorno[0].msgErro);
            }
          }

          this.receiptBase64PDF = response.data.ttDecRendimentos[0].anexo;
          this.infoMessage = locale[window.local].screen.informesRendimentos.string006;

          this.loading = false;
        } else {
          throw new Error();
        }
      } catch (e) {
        this.infoMessage = locale[window.local].screen.informesRendimentos.string007;
        this.loading = false;
        this.setErrorMessage(e.message);
      }
    },
    setErrorMessage(errorMessage) {
      this.showError = true;
      this.errorMessage = errorMessage;
    },
    cleanErrorMessage() {
      this.showError = false;
      this.errorMessage = "";
    },
    getBase64PDF() {
      return this.receiptBase64PDF;
    },
  },
};
</script>

<style scoped>
.text-dados-titulo {
  font-size: 1.5em;
  font-weight: bold;
}

.text-dados-sub-titulo {
  font-size: 1.2em;
  font-weight: bold;
}

.text-filters {
  font-size: 0.9em;
  font-weight: bold;
}

.text-dados {
  font-size: 1.2em;
}
</style>
